import { Grid } from "@mui/material";
import { GridItem } from "Components/Shared/GridItem";
import { FormSection } from "Components/Shared/FormSection";
import { VerificationValue } from "Components/Users/UserDetailPageContent/Components/UserReadOnlyDetail/VerificationValue";
import {
  additionalInfoStatusMap,
  bankVerificationStatusMap,
  identityVerificationStatusMap,
  riskProfileStatusMap,
} from "Components/Users/UserDetailPageContent/Components/UserReadOnlyDetail/verificationStatusUtils";
import type {
  AdditionalInfoStatus,
  BankVerificationStatus,
  IdentityVerificationStatus,
  RiskProfileStatus,
} from "Infrastructure/Api/Api";
import { Resources, useResource } from "Translations/Resources";

const FORM_RESOURCES =
  Resources.Pages.Content.UserDetailPageContent.Tabs.User.Form;

type Props = {
  verificationAdditionalInfoStatus: AdditionalInfoStatus;
  verificationIdentityVerificationStatus: IdentityVerificationStatus;
  verificationRiskProfile: RiskProfileStatus;
  verificationBankVerificationStatus: BankVerificationStatus;
};

export const VerificationSection = ({
  verificationAdditionalInfoStatus,
  verificationIdentityVerificationStatus,
  verificationRiskProfile,
  verificationBankVerificationStatus,
}: Props) => {
  const { t } = useResource();

  return (
    <FormSection legend={t(FORM_RESOURCES.Legend.Verification)} noMargins>
      <Grid container spacing={2}>
        <GridItem
          columns={2}
          label={t(FORM_RESOURCES.VerificationAdditionalInfoStatus)}
          value={
            <VerificationValue
              status={additionalInfoStatusMap[verificationAdditionalInfoStatus]}
              label={t(
                Resources.Form.AdditionalInfo[verificationAdditionalInfoStatus],
              )}
            />
          }
        />
        <GridItem
          columns={2}
          label={t(FORM_RESOURCES.VerificationIdentityVerificationStatus)}
          value={
            <VerificationValue
              status={
                identityVerificationStatusMap[
                  verificationIdentityVerificationStatus
                ]
              }
              label={t(
                Resources.Form.IdentityVerification[
                  verificationIdentityVerificationStatus
                ],
              )}
            />
          }
        />
        <GridItem
          columns={2}
          label={t(FORM_RESOURCES.VerificationRiskProfile)}
          value={
            <VerificationValue
              status={riskProfileStatusMap[verificationRiskProfile]}
              label={t(
                Resources.Common.RiskProfileStatus[verificationRiskProfile],
              )}
            />
          }
        />
        <GridItem
          columns={2}
          label={t(FORM_RESOURCES.VerificationBankVerificationStatus)}
          value={
            <VerificationValue
              status={
                bankVerificationStatusMap[verificationBankVerificationStatus]
              }
              label={t(
                Resources.Form.BankVerification[
                  verificationBankVerificationStatus
                ],
              )}
            />
          }
        />
      </Grid>
    </FormSection>
  );
};
